export default __webpack_public_path__ + "static/media/vitalik_badge_4.0a9d5478.svg";